// @flow

import type {Flipped, CoordinatesType} from './typedef';


type CheckFlipped = ({|
    isTop: boolean,
    isBottom: boolean,
    isLeft: boolean,
    isRight: boolean,
    anchorRect: ClientRect | CoordinatesType,
    portalRect: ClientRect,
    height: number,
    width: number,
    offsetTop: number,
    offsetLeft: number,
|}) => Flipped;

/**
* A util that checks to see if you need to flip.
* @namespace
* @property {object} param - The default values for configuration parameter.
* @property {boolean} param.isTop - If true, the container does not fit on top.
* @property {boolean} param.isBottom - If true, the container does not fit on bottom.
* @property {boolean} param.isLeft - If true, the container does not fit on lift.
* @property {boolean} param.isRight - If true, the container does not fit on right.
* @property {ClientRect | CoordinatesType} param.anchorRect - This is the point on the anchor.
* @property {ClientRect} param.portalRect - This is the position that may be used to set the position of the Box.
* The coordinates are relative to the application's client area.
* @property {number} param.height - Box height.
* @property {number} param.width - Box width.
* @property {number} param.offsetTop - Specifies how close to the edge of the anchor the Box can appear to top.
* @property {number} param.offsetLeft - Specifies how close to the edge of the anchor the Box can appear to left.
* @returns {Flipped}
 @deprecated It will be removed in 6 months 04-28-2026. Use Floating instead.
*/
export const checkFlipped: CheckFlipped = param => {
    const {isTop, isBottom, isLeft, isRight, anchorRect, portalRect, height, width, offsetTop, offsetLeft} = param;

    const nufTopSpace = anchorRect.top < portalRect.height - offsetTop;
    const nufBottomSpace = height - anchorRect.bottom < portalRect.height - offsetTop;
    const nufLeftSpace = width - offsetLeft - anchorRect.left < portalRect.width;
    const nufRightSpace = anchorRect.right - offsetLeft < portalRect.width;

    return {
        height: (isTop && nufBottomSpace && !nufTopSpace) || (isBottom && nufTopSpace && !nufBottomSpace),
        width: (isLeft && nufLeftSpace && !nufRightSpace) || (isRight && nufRightSpace && !nufLeftSpace)
    };
};

            // @pb/generate-flow-typed Webpack Loader:
            // Duplicates all internal dependencies imports
            // to be sure all deps are parsed by this loader
            // cause Babel loader removes `import type ...`
            // and e.g. 'typedef.js' files are not included in dist
            
require("./typedef");
